export const authMethods = [
    { label: "One Time Password (OTP)", value: "One Time Password (OTP)" },
    {
        label: "Secret Questions/Answers",
        value: "Secret Questions/Answers",
    },
    { label: "Profile Information Verification", value: "Profile Information Verification" },
    { label: "Other Methods", value: "Other Methods" },
];
export const cardActivationMethod = ["API", "IVR", "CSR", "At the time of enrollment"];
export const validationInfo = ["Last 4 digits of SSN [for US only]", "SSN [for US only]", "ZIP code", "Last 4 digits of Mobile Number",
    "Expiration Date", "Access Code", "Security Code", "Date of Birth", "PIN Code", "Tax ID"]
export const userCreationInfo = ["Last 4 digits of SSN [for US only]", "SSN [for US only]", "ZIP code",
    "Last 4 digits of Home Phone Number", "Last 4 digits of Mobile Number", "Expiration Date", "Access Code", "Security Code", "Date of Birth", "PIN Code", "Tax ID"]
export const profileVerification = ["Access Code", "Expiry", "Date of Birth", "PIN Code", "Last 4 digits of SSN [for US only]", "Last 4 digits of Home Phone Number"]
export const additionalAuthData = [
    { feature: 'User Creation', alternativeMethod: '', enabled: false },
    { feature: 'Login', alternativeMethod: '', enabled: false },
    { feature: 'Change Password', alternativeMethod: '', enabled: false },
    { feature: 'Add Bank Account', alternativeMethod: '', enabled: false },
    { feature: 'Update Profile', alternativeMethod: '', enabled: false },
    { feature: 'Set Up Security Question', alternativeMethod: '', enabled: false },
    { feature: 'Reissue Card', alternativeMethod: '', enabled: false },
    { feature: 'View Virtual Card Details', alternativeMethod: '', enabled: false },
    { feature: 'File New Dispute', alternativeMethod: '', enabled: false },
    { feature: 'Order Additional Card', alternativeMethod: '', enabled: false },
];
export const additionalAuthDataPrepaid = [
    { feature: 'User Creation', alternativeMethod: '', enabled: false },
    { feature: 'Login', alternativeMethod: '', enabled: false },
    { feature: 'Change Password', alternativeMethod: '', enabled: false },
    { feature: 'View Card Details', alternativeMethod: '', enabled: false },
    { feature: 'View Virtual Card Details', alternativeMethod: '', enabled: false },
    { feature: 'Order Plastic Card', alternativeMethod: '', enabled: false },
    { feature: 'Add Friends & Family', alternativeMethod: '', enabled: false },
    { feature: 'C2B Transfer', alternativeMethod: '', enabled: false },
    { feature: 'International Funds Transfer', alternativeMethod: '', enabled: false },
    { feature: 'Add Bank Account', alternativeMethod: '', enabled: false },
    { feature: 'Update Profile', alternativeMethod: '', enabled: false },
    { feature: 'Set Up Security Question', alternativeMethod: '', enabled: false },
    { feature: 'Reissue Card', alternativeMethod: '', enabled: false },
    { feature: 'File New Dispute', alternativeMethod: '', enabled: false },
    { feature: 'Order Supplementary Card', alternativeMethod: '', enabled: false },
];
